import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import StrianoLogo from "../components/StrianoLogo";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";
import { Mail, CheckCircle2 } from "lucide-react";

import { API_BASE } from "../lib/api";
const BACKEND = API_BASE.replace(/\/api$/, "");

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND}/api/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D16] bg-grid flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center mb-3">
            <StrianoLogo variant="full" size={120}/>
          </div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-mono-num">Password dimenticata</div>
        </div>

        {sent ? (
          <div data-testid="forgot-success" className="rounded-2xl border border-emerald-500/40 bg-emerald-500/10 p-8 text-center space-y-3">
            <CheckCircle2 className="mx-auto text-emerald-400" size={48}/>
            <div className="font-display text-xl font-extrabold text-white">Controlla la tua email</div>
            <div className="text-slate-300 text-sm">
              Se l'indirizzo <strong className="text-white">{email}</strong> è associato a un account autista, riceverai a breve un link per reimpostare la password. Il link è valido per 30 minuti.
            </div>
            <Link data-testid="back-to-login-success" to="/login" className="inline-block mt-2 text-amber-400 hover:text-amber-300 font-semibold text-xs uppercase tracking-widest">← Torna al login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-2xl border border-slate-800 bg-slate-950/80 backdrop-blur-md p-8 space-y-5 shadow-2xl">
            <div className="flex items-center gap-2 text-amber-400">
              <Mail size={18}/>
              <div className="text-xs uppercase tracking-widest font-mono-num">Reset password autista</div>
            </div>
            <div className="text-sm text-slate-400 leading-relaxed">
              Inserisci l'email associata al tuo account autista. Ti invieremo un link per impostare una nuova password.
            </div>
            <div>
              <Label className="text-slate-400 text-xs uppercase tracking-widest">Email</Label>
              <Input data-testid="forgot-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1.5 bg-slate-900 border-slate-800 text-white" placeholder="autista@example.com"/>
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold uppercase tracking-wide">
              {loading ? "Invio in corso..." : "Invia link di reset"}
            </Button>
            <div className="text-xs text-slate-500 text-center pt-2">
              <Link data-testid="back-to-login" to="/login" className="text-amber-400 hover:text-amber-300 font-semibold">← Torna al login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
